/*
 * Pholoh light/dark theme toggle + dark-image swap
 * - Header sun/moon button; flips <html data-theme>, persists to localStorage.
 * - No-flash bootstrap lives in snippets/css-variables.liquid.
 * - DARK_MAP: light-image filename -> dark Shopify URL, or "invert" for pure
 *   black/white charts (safe CSS invert). In dark mode any <img> whose filename
 *   is a map key is swapped to its dark version (product cards, PDP gallery,
 *   homepage, size guide). A MutationObserver catches lazy-loaded/carousel imgs.
 */
(function () {
  'use strict';
  var KEY = 'pholoh-theme';
  var DARK_MAP = {"bleach_20size_20chartsArtboard_201.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130538_17616692-b8e7-48a5-8cb2-5e1564fd6761.png", "bleach_20size_20chartsArtboard_201_20copy.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130850_870cffde-626b-43f1-b5c8-8ff31494b09f.png", "bleach_20size_20chartsArtboard_201_20copy_202.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130853_ecd626fd-a01f-47b6-82cc-0fe69157beee.png", "bleach_20size_20chartsArtboard_201_20copy_203.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130856_0bacb6ec-2e3e-45d4-8f11-ee179945e73d.png", "bleach_20size_20chartsArtboard_201_20copy_204.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130900_7369f077-bdd4-494e-a9b8-03f551501535.png", "spring_tees_size_chartsArtboard_1.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_131504_0edab8da-2b9e-4897-84c5-6b242becba96.png", "spring_tees_size_chartsArtboard_1_copy.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130906_14427faa-fefd-43dc-9886-37fbd5eeb146.png", "spring_tees_size_chartsArtboard_1_copy_2.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130909_e4d7c62c-19ac-442d-9594-99295a852097.png", "spring_tees_size_chartsArtboard_1_copy_4.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130912_c47b7b51-87aa-4d86-aa40-1138ad739efc.png", "spring_tees_size_chartsArtboard_1_copy_5.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130915_9a120048-9f3c-41cd-8553-39ebfeb95c4d.png", "spring_tees_size_chartsArtboard_1_copy_6.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/hf_20260725_130918_119b6691-f437-4bbf-b692-694aaff997ad.png", "F6DE87F1-398F-4AF5-AAEB-2440455A6FDD.jpg": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28.webp": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28_1.webp": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28_2.webp": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28_3.webp": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28_4.webp": "invert", "SmartSize_WhatsApp_Image_2025-07-12_at_01.47.28_5.webp": "invert", "buy2get1-banner.jpg": "https://cdn.shopify.com/s/files/1/0562/5947/7565/files/buy2get1-banner-dark.jpg"}; /* Diego 2026-07-25: TEE PRODUCT photos NOT swapped (kept light concrete). Swaps = 18 size charts + the B2G1 hero banner (buy2get1-banner.jpg -> black-bg dark version). */ /* Diego 2026-07-25: TEE PRODUCT photos removed from swap (kept light concrete originals in dark mode — dark versions had wrong ratio/bar/recolored concrete). SIZE CHARTS kept (Diego: they look good in dark). */

  function current(){ return 'dark'; } /* JJK DRAFT 2026-10-06: all black */ /* WHITE THEME BUILD 2026-09-07 - see css-variables.liquid */

  function fileKey(src){
    if(!src) return '';
    var s=src.split('?')[0].split('#')[0];
    var base=s.substring(s.lastIndexOf('/')+1);
    if(base in DARK_MAP) return base;
    var m=base.match(/^(.*?)(?:_\d+x\d*)(\.[a-z0-9]+)$/i);
    if(m && (m[1]+m[2]) in DARK_MAP) return m[1]+m[2];
    return '';
  }
  function widthOf(src){ var m=/[?&]width=(\d+)/.exec(src||''); return m?m[1]:''; }

  function processImg(img, theme){
    var k=img.getAttribute('data-ph-key');
    if(k===null){
      var src=img.currentSrc||img.getAttribute('src')||'';
      if(!src || src.indexOf('data:')===0) return;
      k=fileKey(src);
      img.setAttribute('data-ph-key', k);
      if(k){
        img.setAttribute('data-ph-light-src', img.getAttribute('src')||src);
        var ss=img.getAttribute('srcset'); if(ss) img.setAttribute('data-ph-light-srcset', ss);
      }
    }
    if(!k) return;
    var val=DARK_MAP[k];
    if(theme==='dark'){
      if(val==='invert'){
        if(img.style.filter!=='invert(1)') img.style.filter='invert(1)';
      } else {
        if(img.style.filter) img.style.filter='';
        var w=widthOf(img.getAttribute('data-ph-light-src'));
        var target=val+(w?('?width='+w):'');
        if(img.getAttribute('srcset')) img.removeAttribute('srcset');
        if((img.getAttribute('src')||'')!==target) img.setAttribute('src', target);
      }
    } else {
      if(img.style.filter) img.style.filter='';
      var ls=img.getAttribute('data-ph-light-src');
      if(ls && (img.getAttribute('src')||'')!==ls) img.setAttribute('src', ls);
      var lss=img.getAttribute('data-ph-light-srcset');
      if(lss && img.getAttribute('srcset')!==lss) img.setAttribute('srcset', lss);
    }
  }

  var applying=false;
  function swapAll(theme){
    applying=true;
    var imgs=document.getElementsByTagName('img');
    for(var i=0;i<imgs.length;i++) processImg(imgs[i], theme);
    applying=false;
  }
  window.pholohSwapThemeImages=swapAll;

  var mo;
  function startObserver(){
    if(mo) return;
    mo=new MutationObserver(function(muts){
      if(applying) return;
      var th=current();
      for(var i=0;i<muts.length;i++){
        var m=muts[i];
        if(m.type==='attributes' && m.target.tagName==='IMG'){ processImg(m.target, th); }
        else if(m.addedNodes){
          for(var j=0;j<m.addedNodes.length;j++){
            var n=m.addedNodes[j]; if(n.nodeType!==1) continue;
            if(n.tagName==='IMG') processImg(n, th);
            else if(n.getElementsByTagName){ var q=n.getElementsByTagName('img'); for(var x=0;x<q.length;x++) processImg(q[x], th); }
          }
        }
      }
    });
    mo.observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset']});
  }

  function apply(theme){
    document.documentElement.setAttribute('data-theme', theme);
    try{ localStorage.setItem(KEY, theme); }catch(e){}
    var label=theme==='dark'?'Switch to light mode':'Switch to dark mode';
    var btns=document.querySelectorAll('.pholoh-theme-toggle');
    for(var i=0;i<btns.length;i++){ btns[i].setAttribute('aria-label',label); btns[i].setAttribute('title',label); btns[i].setAttribute('aria-pressed', theme==='dark'?'true':'false'); }
    swapAll(theme);
  }
  function toggle(){ apply(current()==='dark'?'light':'dark'); }

  var ICONS='<svg class="pholoh-moon" viewBox="0 0 24 24" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg><svg class="pholoh-sun" viewBox="0 0 24 24" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/></svg>';
  function makeButton(){ var b=document.createElement('button'); b.type='button'; b.className='site-nav__link site-nav__link--icon pholoh-theme-toggle'; b.innerHTML=ICONS; b.addEventListener('click',function(e){e.preventDefault();toggle();}); return b; }
  function inject(){
    var rows=document.querySelectorAll('.site-nav__icons');
    /* toggle button removed - permanent dark */
    startObserver();
    apply(current());
  }
  if(document.readyState!=='loading') inject(); else document.addEventListener('DOMContentLoaded', inject);
  window.addEventListener('load', function(){ swapAll(current()); });
})();


/* === upsell strip arrows 2026-07-29 === */
(function(){
  'use strict';
  function inject(up){
    if(up.querySelector('.pholoh-upsell__arrows')) return;
    var strip = up.querySelector('.pholoh-upsell__strip');
    var top = up.querySelector('.pholoh-upsell__top');
    if(!strip || !top) return;
    var wrap = document.createElement('div');
    wrap.className = 'pholoh-upsell__arrows';
    function mk(dir, label){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pholoh-upsell__arrow';
      b.setAttribute('aria-label', label);
      b.innerHTML = dir < 0 ? '&#8249;' : '&#8250;';
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var card = strip.querySelector('.pholoh-upsell__card');
        var step = card ? card.getBoundingClientRect().width + 12 : strip.clientWidth * 0.8;
        strip.scrollBy({left: dir * step, behavior: 'smooth'});
      });
      return b;
    }
    wrap.appendChild(mk(-1, 'Previous product'));
    wrap.appendChild(mk(1, 'Next product'));
    top.appendChild(wrap);
  }
  function scan(){ document.querySelectorAll('.pholoh-upsell').forEach(inject); }
  if(document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(function(){ scan(); }).observe(document.documentElement, {childList: true, subtree: true});
})();
